// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor2 from '@/game/prefabs/World/Mentors/Mentor2';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level6 extends TilemapScene {
  constructor() {
    super('Level6');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // spring_biome_1
    const spring_biome_1 = this.add.tilemap('spring-biome-1');
    spring_biome_1.addTilesetImage(
      'spring forest wang tiles',
      'spring forest wang tiles',
    );
    spring_biome_1.addTilesetImage('spring forest', 'spring forest');
    spring_biome_1.addTilesetImage(
      'spring trees 80x112',
      'spring trees 80x112',
    );
    spring_biome_1.addTilesetImage(
      'spring water sparkles B',
      'spring water sparkles B',
    );
    spring_biome_1.addTilesetImage('spring 32x32', 'spring 32x32');
    spring_biome_1.addTilesetImage('collision', 'collision & alpha');
    spring_biome_1.addTilesetImage(
      'winter water sparkles B 16x16',
      'spring water sparkles B',
    );

    // terrain_1
    spring_biome_1.createLayer(
      'terrain',
      ['spring forest wang tiles', 'spring forest'],
      0,
      0,
    );

    // deco
    spring_biome_1.createLayer(
      'deco 1',
      ['spring forest', 'spring 32x32', 'spring water sparkles B'],
      0,
      0,
    );

    // player
    const player = new Player(this, 64, 64);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 224, 128);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 96, 304);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 336, 384);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 544, 416);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 656, 208);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 432, 176);
    this.add.existing(worldNode_5);

    // forestTree1
    const forestTree1 = new ForestTree1(this, 0, 240, 'spring_trees_sheet', 0);
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 464, 112, 'spring_trees_sheet', 0);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      464,
      400,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      208,
      544,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      432,
      560,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      16,
      432,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      48,
      368,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      240,
      256,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      544,
      48,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      704,
      128,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      208,
      32,
      'spring_trees_sheet',
      1,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(this, 0, 64, 'spring_trees_sheet', 1);
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      160,
      64,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      32,
      272,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      32,
      464,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_13);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      592,
      32,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      400,
      80,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      256,
      80,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      688,
      48,
      'spring_trees_sheet',
      2,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      640,
      80,
      'spring_trees_sheet',
      0,
    );
    this.add.existing(forestTree_18);

    // portal
    const portal = new Portal(this, 480, 448);
    this.add.existing(portal);

    // forestTree_19
    const forestTree_19 = new ForestTree1(this, 384, 160, 'spring 32x', 0);
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(this, 384, 160, 'spring 32x', 0);
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(this, 112, 128, 'spring 32x', 1);
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(this, 272, 144, 'spring 32x', 1);
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(this, 432, 256, 'spring 32x', 1);
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(this, 640, 144, 'spring 32x', 1);
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(this, 416, 400, 'spring 32x', 1);
    this.add.existing(forestTree_25);

    // forestTree_26
    const forestTree_26 = new ForestTree1(this, 272, 496, 'spring 32x', 1);
    this.add.existing(forestTree_26);

    // forestTree_27
    const forestTree_27 = new ForestTree1(this, 368, 528, 'spring 32x', 1);
    this.add.existing(forestTree_27);

    // forestTree_28
    const forestTree_28 = new ForestTree1(this, 176, 512, 'spring 32x', 1);
    this.add.existing(forestTree_28);

    // forestTree_29
    const forestTree_29 = new ForestTree1(this, 112, 496, 'spring 32x', 1);
    this.add.existing(forestTree_29);

    // forestTree_30
    const forestTree_30 = new ForestTree1(this, 64, 448, 'spring 32x', 1);
    this.add.existing(forestTree_30);

    // forestTree_31
    const forestTree_31 = new ForestTree1(this, 96, 384, 'spring 32x', 0);
    this.add.existing(forestTree_31);

    // forestTree_32
    const forestTree_32 = new ForestTree1(this, 160, 432, 'spring 32x', 0);
    this.add.existing(forestTree_32);

    // forestTree_33
    const forestTree_33 = new ForestTree1(this, 208, 448, 'spring 32x', 0);
    this.add.existing(forestTree_33);

    // forestTree_34
    const forestTree_34 = new ForestTree1(this, 320, 480, 'spring 32x', 0);
    this.add.existing(forestTree_34);

    // forestTree_35
    const forestTree_35 = new ForestTree1(this, 352, 448, 'spring 32x', 0);
    this.add.existing(forestTree_35);

    // forestTree_36
    const forestTree_36 = new ForestTree1(this, 432, 432, 'spring 32x', 0);
    this.add.existing(forestTree_36);

    // forestTree_37
    const forestTree_37 = new ForestTree1(this, 688, 272, 'spring 32x', 0);
    this.add.existing(forestTree_37);

    // mentor
    const mentor = new Mentor2(this, 112, 48);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 400, 464);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 288, 296);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 144, 176);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 112, 456);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 5;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 5;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 5;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 5;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 5;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 5;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 5;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 5;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 5;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 5;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.spring_biome_1 = spring_biome_1;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor2;
  private spring_biome_1!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.spring_biome_1,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
